var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.833 17.3334C14.4056 18.099 15.1362 18.7324 15.9751 19.1907C16.814 19.649 17.7417 19.9216 18.6952 19.9899C19.6487 20.0582 20.6058 19.9206 21.5015 19.5865C22.3971 19.2524 23.2105 18.7295 23.8863 18.0534L27.8863 14.0534C29.1007 12.7961 29.7727 11.1121 29.7575 9.36411C29.7423 7.61613 29.0412 5.94405 27.8051 4.70799C26.5691 3.47194 24.897 2.77081 23.149 2.75562C21.401 2.74043 19.717 3.4124 18.4597 4.62678L16.1663 6.90678",
    stroke: "#374956",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.166 14.6666C18.5934 13.9011 17.8628 13.2677 17.0239 12.8094C16.185 12.351 15.2573 12.0785 14.3038 12.0102C13.3502 11.9419 12.3932 12.0795 11.4975 12.4136C10.6018 12.7477 9.78847 13.2705 9.11262 13.9466L5.11262 17.9466C3.89824 19.204 3.22627 20.888 3.24146 22.636C3.25665 24.384 3.95778 26.056 5.19383 27.2921C6.42989 28.5282 8.10197 29.2293 9.84995 29.2445C11.5979 29.2597 13.2819 28.5877 14.5393 27.3733L16.8193 25.0933",
    stroke: "#374956",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.ce55ae4f70eed2d5611069e6a0061c6d.svg";
export { ForwardRef as ReactComponent };